import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  totalQuantity: 0,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    updateCart: (state, action) => {
      state.items = action.payload.cart;
      state.totalQuantity = action.payload.totalQuantity;
    },
    addToCart: (state, action) => {
      const { id, quantity, size, color, price } = action.payload;

      // Check if the product with the same id, size, and color already exists
      const existingItem = state.items.find(
        (item) => item.id === id && item.size === size && item.color === color
      );

      if (existingItem) {
        // If it exists, update the quantity
        existingItem.quantity += quantity;
      } else {
        // If not, add a new item to the cart
        state.items.push({ id, quantity, size, color, price });
      }

      // Update total quantity and price
      state.totalQuantity += quantity;
    },

    removeFromCart: (state, action) => {
      const { id, size, color } = action.payload;

      // Find the item index in the cart
      const index = state.items.findIndex(
        (item) => item.id === id && item.size === size && item.color === color
      );

      if (index !== -1) {
        const item = state.items[index];

        // Update total quantity and price before removing the item
        state.totalQuantity -= item.quantity;

        // Remove item from the cart
        state.items.splice(index, 1);
      }
    },

    updateQuantity: (state, action) => {
      const { id, size, color, quantity } = action.payload;

      const existingItem = state.items.find(
        (item) => item.id === id && item.size === size && item.color === color
      );

      if (existingItem && quantity > 0) {
        // Update total quantity and price based on the difference
        const quantityDifference = quantity - existingItem.quantity;
        state.totalQuantity += quantityDifference;
        existingItem.quantity = quantity;
      }
    },

    clearCart: (state) => {
      state.items = [];
      state.totalQuantity = 0;
    },
  },
});

export const { addToCart, removeFromCart, updateQuantity, clearCart, updateCart } = cartSlice.actions;

export default cartSlice.reducer;
